import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulOffer from '@entries/contentful-offer'
import { withDisplayName } from '@hocs/with-display-name'
import { OpenFormButton } from '@layouts/open-form-button'
import { Entry } from '@resolvers/entry'
import { clsx } from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  objectFit: 'contain',
  width: 'auto',
  height: 'auto',
}

const ContentfulPageImageTitleHero: Utils.EntryFC<
  Queries.ContentfulPageImageTitleHeroFragment
> = ({
  content: { headline, image, offerRef },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div className="grid grid-cols-12 gap-6" {...entryInspectorProps()}>
    <div
      className={clsx(
        'col-span-12 text-center laptop:text-left',
        image ? 'laptop:col-span-6' : 'laptop:col-span-12'
      )}
    >
      <h1
        className={clsx('text-085 uppercase', {
          'sr-only': Boolean(offerRef?.title),
        })}
      >
        {headline?.text}
      </h1>
      <Entry
        content={offerRef}
        mapping={{
          [ContentType.ContentfulOffer]: ContentfulOffer,
        }}
      />
      <OpenFormButton />
    </div>
    {image && (
      <div
        className="col-span-12 flex items-center laptop:col-span-6"
        {...fieldInspectorProps({
          fieldId: 'image',
        })}
      >
        <AssetOptionsContext.Provider value={assetOptions}>
          <Entry
            content={image}
            mapping={{
              [ContentType.ContentfulAsset]: ContentfulAsset,
            }}
          />
        </AssetOptionsContext.Provider>
      </div>
    )}
  </div>
)

export const query = graphql`
  fragment ContentfulPageImageTitleHero on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    headline {
      text
    }
    image {
      ...ContentfulDefaultAsset
    }
    offerRef {
      ...ContentfulOffer
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitleHero,
  'ContentfulPageImageTitleHero'
)
